import { Component, ViewChild, OnInit, EventEmitter, Output, Input } from '@angular/core'
import { jqxTreeGridComponent } from 'jqwidgets-ng/jqxtreegrid'
import { jqxDropDownButtonComponent } from 'jqwidgets-ng/jqxdropdownbutton'
import { CurrentUserGateway } from '../../gateways/current-user-gateway'
import { OrgHierarchy } from '../../models/orgHeirarchy'
import { CommonGateway } from '../../gateways/common-gateway'
import { CurrentUser } from '../../models/current-user'
import { PortalGlobals } from '../../../portalglobals'

@Component({
    selector: 'jq-org-dropdown',
    templateUrl: 'orgTreeViewDropdown.Component.html'
})
export class OrgTreeView implements OnInit {
    @ViewChild('myTree', { static: true }) myTree: jqxTreeGridComponent
    @ViewChild('myDropDownButton', { static: true }) myDropDownButton: jqxDropDownButtonComponent
    jqx: any
    organizations: OrgHierarchy[] = [] as OrgHierarchy[]
    noneField: OrgHierarchy = {} as OrgHierarchy
    @Input() selectedParent: string
    @Output() onValueChange: EventEmitter<string> = new EventEmitter<string>()
    currentUser: CurrentUser = {} as CurrentUser
    isSelected: boolean = false
    selectedOrgIPVString: string
    // rowId: number
    source = {
        datatype: 'json',
        datafields: [{ name: 'CurrentOrgID' }, { name: 'CurrentOrgParentOrgID' }, { name: 'text' }, { name: 'value' }, { name: 'OrganizationIPV' }],
        hierarchy: {
            keyDataField: { name: 'CurrentOrgID' },
            parentDataField: { name: 'CurrentOrgParentOrgID' }
        },
        id: 'CurrentOrgID',
        localdata: this.organizations
    }
    dataAdapter = new jqx.dataAdapter(this.source)
    // records = this.dataAdapter.getRecordsHierarchy('CurrentOrgID', 'CurrentOrgParentOrgID', 'items', [{ name: 'text', map: 'label' }])
    columns = [{ text: 'Org Name', dataField: 'text', width: 300 }]

    myTreeOnInitialized(): void {
        // to do during dropdown initialization
    }

    ready(): void {
        //  console.log(this.myTree.getRow("SilverScript")
        if (this.myTree !== undefined) this.myTree.expandRow(2)
    }

    CellclickOnEdit(event: any): void {
        let args = event.args
        // row's data.
        let rowData = args.row

        let itemValue = event.args.row.CurrentOrgID
        let item = event.args.row.text

        this.onValueChange.emit(itemValue)
        let dropDownContent = '<div style="position: relative; margin-left: 3px; margin-top: 4px;">' + item + '</div>'
        this.myDropDownButton.setContent(dropDownContent)
        this.myDropDownButton.close()
        if (rowData.OrganizationIPV != undefined && rowData.OrganizationIPV != '' && rowData.OrganizationIPV != null) {
            this._commonGateway.getIPVString(rowData.OrganizationIPV).subscribe(
                (model: string) => {
                    if (model != null && model != '') {
                        this.isSelected = true
                        this.selectedOrgIPVString = model
                    } else {
                        this.isSelected = false
                    }
                },
                (error) => {
                    this.isSelected = false
                }
            )
        } else {
            this.isSelected = false
        }
    }

    public onDataLoad(parentName: any): void {
        // update databound
        let dropDownContent = '<div style="position: relative; margin-left: 3px; margin-top: 4px;">' + parentName + '</div>'
        this.myDropDownButton.setContent(dropDownContent)
        if (parentName == '') this.isSelected = false
    }

    constructor(private _commonGateway: CommonGateway, private _currentUserGateway: CurrentUserGateway, private _global: PortalGlobals) {}

    ngOnInit() {
        this.noneField.CurrentOrgID = null
        this.noneField.CurrentOrgParentOrgID = 0
        this.noneField.text = 'None'
        this.noneField.value = '0'
        this._currentUserGateway.getCurrentUser().subscribe((user: CurrentUser) => {
            this.currentUser = user
            if (this._global.currentUser.IsGuruAdmin || this._global.currentUser.IsSuperAdminAdmin) {
                //if (this.currentUser.roleId === 1 || this.currentUser.roleId === 2) {
                this.organizations.push(this.noneField)
            }
            this.getParents()
        })
        // this.getParents()
    }
    private getParents() {
        let OrgId
        if (this.currentUser.IsSuperAdminAdmin || this.currentUser.IsGuruAdmin) OrgId = this.currentUser.insuranceCompanyId
        else OrgId = this.currentUser.orgId
        this._commonGateway.getOrgHierarchy(OrgId).subscribe((model: OrgHierarchy[]) => {
            // this.organizations = model
            let orgdata: OrgHierarchy[] = model
            for (let i = 0; i < orgdata.length; i++) {
                this.organizations.push(orgdata[i])
            }
            this.source.localdata = this.organizations
            this.dataAdapter.dataBind()
            this.myTree.updateBoundData()
            this.myTree.expandAll()

            var userOrg = sessionStorage.getItem('editUserOrg')
            if (userOrg !== undefined && userOrg !== null) {
                this._commonGateway.getOrgIPV(parseInt(userOrg)).subscribe((orgIPV: number[]) => {
                    if (orgIPV != null) {
                        for (var org of orgIPV) {
                            // console.log(org)
                            if (this.myTree !== undefined) this.myTree.expandRow(org)
                        }
                    }
                })
                this.myTree.selectRow(userOrg)
            }
            sessionStorage.removeItem('editUserOrg')
        })
    }
}
